class AvatarErrorsService {
  constructor() {
    this.requestedAvatars = new Map();
  }

  addError(avatar) {
    if (avatar) {
      this.requestedAvatars.set(avatar, true);
    }
  }

  hasError(avatar) {
    return this.requestedAvatars.get(avatar);
  }
}

export default AvatarErrorsService;
